import React from "react";
import { useGame, useMyDocuments } from "@seabrookstudios/pitch2table";
import { idExtractor, useMakeListAndDetail, useMakeListBuilder } from "../core/useMakeLayout";
import { NoItemsFound } from "../publisher/NoItemsFound";
import { Path } from "../Path";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Skeleton from "@mui/material/Skeleton";
import { useAttachmentIdFromRoute } from "../games/WithGameIdFromRoute";
import { formatFullDate } from "@seabrookstudios/pitch2table-core";
import { CoverSquare } from "../games/CoverImages";
import { MyDocumentsDetailFromRoute } from "./DocumentsDetailView";
import { PublisherContractListEntry } from "../publishers/ListItem";

const NotFound = () => (
  <NoItemsFound>
    <Alert severity="info">
      When you upload contracts against publishers (e.g. an NDA) or for a game (e.g. a contract), they will appear here.
    </Alert>
  </NoItemsFound>
);

/**
 * @param {Object} props
 * @param {import("@seabrookstudios/pitch2table-core").DocumentListEntry} props.item
 */
export const GameContractListEntry = ({ item }) => {
  const attachmentId = useAttachmentIdFromRoute();
  const { data: game } = useGame(/** @type {import("@seabrookstudios/types").GameId} */ (item.refId));
  const navigate = useNavigate();

  const selected = attachmentId === item.id;

  const onClickHandler = () => {
    navigate(Path.document(item.id));
  };

  if (!game) {
    return (
      <ListItemButton alignItems="flex-start" selected={selected} onClick={onClickHandler}>
        <ListItemAvatar>
          <Skeleton width={48} height={48} />
        </ListItemAvatar>
        <ListItemText primary={<Skeleton />} secondary={<Skeleton />} />
      </ListItemButton>
    );
  }

  const secondary = !!item.signedDate
    ? `Signed: ${formatFullDate(item.signedDate)}`
    : `Created ${formatFullDate(item.created)}`;

  return (
    <ListItemButton alignItems="flex-start" selected={selected} onClick={onClickHandler}>
      <ListItemAvatar>
        <CoverSquare game={game} width={48} height={48} />
      </ListItemAvatar>
      <ListItemText primary={`${game.name} - ${item.name}`} secondary={secondary} />
    </ListItemButton>
  );
};

/**
 * @param {Object} props
 * @param {import("@seabrookstudios/pitch2table-core").DocumentListEntry} props.item
 */
export const MyDocumentListEntry = ({ item }) => {
  if (item.refType === "GameId") {
    return <GameContractListEntry item={item} />;
  }

  return <PublisherContractListEntry item={item} />;
};

export const DocumentsListAndDetail = () => {
  const useMakeList = useMakeListBuilder(MyDocumentListEntry, idExtractor, "My Secure Documents", NotFound);

  const ListAndDetail = useMakeListAndDetail(useMyDocuments, [], "contracts", useMakeList, MyDocumentsDetailFromRoute);

  return <ListAndDetail />;
};
